import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { InscritosOCMResultDto } from "../models/filtroConsultaOCM";
import { RowConsultaOCM } from "../models/rowConsultaOCM";

const consultarInscritosOCM = async (estado: string) => {
  return axiosInstance.get<ListResponseDto<RowConsultaOCM>>(
    `siscred-api-dividendos/v1/pago/buscar-inscritos-ocm`,
    {
      params: { estado },
      headers: { 'X-Hide-Toast': 'true' }
    }
  );
};

const descargarExcelOCM = async() => {
    const response: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-reportes/v1/ocm/descargar-excel`);
    return response;
}

const enviarOCM = async() => {
  const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-dividendos/v1/pago/enviar-ocm`, {});
    return response;
}

export {consultarInscritosOCM, descargarExcelOCM, enviarOCM}
